export default class I18n {
	constructor() {

	}

	static global() {
		return globalApplicationTranslations;
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/classes/translations.js